'use client';

import { Theme, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { biometricConfidenceLevelName } from './ladder';
import { TBiometricConfidenceLevel } from './types';

export type TBiometricConfidenceLabelProps = {
  level: TBiometricConfidenceLevel;
};

/**
 * The biometric confidence level, in words.
 *
 * Separate from the meter rather than part of it, because the design uses the name in two different
 * shapes: as the lead of the guidance sentence on the check card, and standalone beside the bars in
 * the evidence dialog's header. One component cannot be both, so the meter draws bars and this draws
 * the name.
 *
 * Unlike the document axis, this one has no accordion placement: there is no biometric equivalent of
 * the KYC/KYB summary row.
 */
export default function BiometricConfidenceLabel({
  level,
}: Readonly<TBiometricConfidenceLabelProps>): ReactElement {
  return (
    <Typography variant="body2" sx={(t: Theme) => ({ fontWeight: t.semantic.fontWeight.semibold })}>
      {biometricConfidenceLevelName(level)}
    </Typography>
  );
}
